// extracted by mini-css-extract-plugin
export default {"advertWrapper":"IgzGXnvV","advert":"ah2Scub0","placeholder":"AdUnit_placeholder__IGTABKBW","background":"AdUnit_background__kCa2bO2L","content":"AdUnit_content__1b+ngizV"};